<script>
    export let min;
    export let max;
    export let center;
    export let min_label;
    export let max_label;
    export let center_label;
    export let static_pos; // the number for the static axis
    export let horizontal; // if the marker is horizontal
    export let region;
    export let striped; // if the marker is stripped

    let circle_static_axis, circle_dynamic_axis;
    let line_static_axis, line_dynamic_axis, hashType;
    if (horizontal) {
        circle_static_axis = 'cy';
        circle_dynamic_axis = 'cx';
        line_static_axis = 'y';
        line_dynamic_axis = 'x';
        hashType = 'Horizontal';
    } else {
        circle_static_axis = 'cx';
        circle_dynamic_axis = 'cy';
        line_static_axis = 'x';
        line_dynamic_axis = 'y';
        hashType = 'Vertical';
    }

    let circle_props, line_props, lower_text_props, upper_text_props, center_text_props;
    let text_shift = 10; // how much to shift text away from line
    $: {
        circle_props = {
            [circle_static_axis]: static_pos,
            [circle_dynamic_axis]: center
        };

        line_props = {
            [`${line_static_axis}1`]: static_pos,
            [`${line_static_axis}2`]: static_pos,
            [`${line_dynamic_axis}1`]: min,
            [`${line_dynamic_axis}2`]: max
        };

        lower_text_props = (horizontal
            ? {
                alignmentBaseline: 'middle',
                dx: -text_shift,
                dy: 1,
                textAnchor: 'end'
            } : {
                alignmentBaseline: 'hanging',
                dx: 0,
                dy: text_shift,
                textAnchor: 'middle'
            }
        );
        upper_text_props = (horizontal
            ? {
                alignmentBaseline: 'middle',
                dx: text_shift - 2,
                dy: 1,
                textAnchor: 'start'
            } : {
                alignmentBaseline: 'baseline',
                dx: 0,
                dy: -text_shift,
                textAnchor: 'middle'
            }
        );
        let is_canada = region === 'canada';
        center_text_props = {
            ...(horizontal
                ? {
                    alignmentBaseline: is_canada ? 'baseline' : 'hanging',
                    dx: 0,
                    dy: is_canada ? -text_shift : text_shift,
                    textAnchor: 'middle'
                } : {
                    alignmentBaseline: 'middle',
                    dx: is_canada ? -text_shift : text_shift,
                    dy: 0,
                    textAnchor: is_canada ? 'end' : 'start'
                }
            )
        };
    }

    let show_text;
    const handleMouseOver = (e) => {
		show_text = true;
	};
	const handleMouseOut = (e) => {
		show_text = false;
	};
</script>



{#if min && max}
    <line 
        x1={line_props.x1} 
        x2={line_props.x2} 
        y1={line_props.y1} 
        y2={line_props.y2} 
        stroke={striped ? `url(#${region}${hashType}DiagonalHatch)` : 'inherit'}
        on:mouseover={handleMouseOver} 
        on:mouseout={handleMouseOut}
    />
    {#if show_text}
        <text 
            class="marker-text"
            alignment-baseline={lower_text_props.alignmentBaseline}
            dx={lower_text_props.dx}
            dy={lower_text_props.dy}
            text-anchor={lower_text_props.textAnchor}
            transform={`translate(${line_props.x1} ${line_props.y1})`} 
        >
            {min_label}
        </text>
        <text 
            class="marker-text"
            alignment-baseline={upper_text_props.alignmentBaseline}
            dx={upper_text_props.dx}
            dy={upper_text_props.dy}
            text-anchor={upper_text_props.textAnchor}
            transform={`translate(${line_props.x2} ${line_props.y2})`} 
        >
            {max_label}
        </text>
    {/if}
{/if}
{#if center}
    <circle 
        cx={circle_props.cx} 
        cy={circle_props.cy} 
        r="6" 
        on:mouseover={handleMouseOver} 
        on:mouseout={handleMouseOut}
    />
    {#if show_text}
        <text 
            class="marker-text"
            alignment-baseline={center_text_props.alignmentBaseline}
            dx={center_text_props.dx}
            dy={center_text_props.dy}
            text-anchor={center_text_props.textAnchor}
            transform={`translate(${circle_props.cx} ${circle_props.cy})`} 
        >
            {center_label}
        </text>
    {/if}
{/if}

<style>
    line {
        stroke-width: 12px;
        stroke-linecap: round
    }
    .marker-text {
        font-family: Helvetica, Helvetica Neue, Arial, sans-serif;
        font-size: 12px;
        font-weight: 100;
        stroke: #555;
    }
</style>

